// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"90fa7817","239":"03d865ea","455":"492213f5"}[chunkId] + ".chunk.js";
};